import { getGeo } from '@/lib/api';

// Use sessionStorage so geo data does not persist across browsing sessions.
// (geo isn't sensitive PII per se but there's no reason to keep it cross-session)
const CACHE_KEY = 'cauratech_geo_v1';
const CACHE_TTL_MS = 1000 * 60 * 60 * 6; // 6 hours within the same tab session

const FALLBACK_GEO = Object.freeze({
  city: null,
  country: 'Latin America',
  country_code: 'VE',
  continent: 'SA',
  continent_name: 'South America',
  lat: -15.0,
  lng: -60.0,
});

function safeReadCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && parsed.t && Date.now() - parsed.t < CACHE_TTL_MS) {
      return parsed.data;
    }
    return null;
  } catch (err) {
    // Private mode / quota / disabled storage — log but don't crash UX.
    if (typeof console !== 'undefined') console.warn('[geo] cache read failed:', err?.message || err);
    return null;
  }
}

function safeWriteCache(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data }));
  } catch (err) {
    if (typeof console !== 'undefined') console.warn('[geo] cache write failed:', err?.message || err);
  }
}

export async function fetchUserGeo() {
  const cached = safeReadCache();
  if (cached) return cached;

  try {
    const data = await getGeo();
    safeWriteCache(data);
    return data;
  } catch (err) {
    if (typeof console !== 'undefined') console.warn('[geo] backend lookup failed, using fallback:', err?.message || err);
    return FALLBACK_GEO;
  }
}
